import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'

export class DynamicFeaturedCollection extends React.PureComponent<DynamicFeaturedCollection.Props, DynamicFeaturedCollection.State> {
  public static sectionId = 'collect';
  private hasArrows = !this.props.section.settings.addArrows;


  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  })
  
  private sliderRef;

  public constructor(props:DynamicFeaturedCollection.Props) {
    super(props)
    this.sliderRef = React.createRef()
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.state = {
      products: [],
      wishlist: []
    }
  }
  
  next() {
    this.sliderRef.current.slickNext()
  }
  previous() {
    this.sliderRef.current.slickPrev()
  }

  public componentDidMount = async () => {
    const { settings, blocks } = this.props.section
    const featuredProductsFilter = blocks.filter(({ settings }) => {
      return settings.product !== ''
    })
    const featuredProducts = featuredProductsFilter.map(({ settings }) => {
      return settings.product
    })
    const featuredCollection = Helpers.check(settings, 'settings.collection.products') ? settings.collection.products : []
    const products = [...featuredProducts, ...featuredCollection]
    const newProducts = await this.getSwatchdata(products)
    this.setState({
      products: newProducts
    })
    this.fetchWishlistItems()
  }

  private getSwatchdata = async (products) => {
    const tags = []
    products.forEach(product => {
      tags.push(`colours:${[product.handle]}`)
    })
    const siblingsResults = await DynamicFeaturedCollection.kewl.productsBySwatchTags(tags)
    const newProducts = []
    products.forEach(product => {
      if (!product || !product.handle) return
      const underlinedHandle = product.handle.replace(/\-/g, '_')// eslint-disable-line no-useless-escape
      const siblingsQuantity = siblingsResults[underlinedHandle]?.length
      const filteredSiblings = siblingsResults[underlinedHandle]?.filter(sibling => sibling.handle !== product.handle)
      newProducts.push({ ...product, siblingsQuantity: siblingsQuantity, filteredSiblings: filteredSiblings })
    })
    return newProducts
  }

  public fetchWishlistItems = () => {
    if (!window._swat || !window._swat.retailerSettings) {
      // console.error("Swat is not initialized");
      setTimeout(() => {
        this.fetchWishlistItems()
      }, 1000)
    } else {
      window._swat?.fetch((res: any) => {
        // console.log("res:", res);
        this.setState({ wishlist: res })
        document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
      })
    }
  };
  
  public checkWishlistItem = (product: any) => {
    const { wishlist } = this.state
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    // console.log('wishlist', wishlist)
    // console.log('product', product)
    if (wishlist.length === 0) {
      console.warn('wishlist is empty')
      return false
    }

    // check if item.id matches any of the res.epi
    const isRes = wishlist.some((r: any) => {
      return r.epi === productId || 
        r.empi === productId || 
        r.epi === productVariantId
    })

    if (isRes) {
      // console.log('wishlist item found')
      return true
    }
    // console.log('wishlist item not found')
    return false
  };
  
  public toggleWishlist = (product: any, isInList: boolean): void => {
    const _this = this
    
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    
    const productData = {
      ...window.SwymPageData,
      et: 4, // et 4 stands for wishlist event type
      epi: productVariantId, // unique variant ID of the product.
      empi: productId, // Product ID or master product ID
      du: `${window.location.origin}/products/${product.handle}`
    }
    
    if (isInList) {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    } else {
      window._swat.addToWishList(
        productData,
        function (e: any) {
          console.log('wishlist item added', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  }
  
  public render(): JSX.Element {
    const { settings } = this.props.section
    const { products } = this.state
    
    const { article } = this.props.data.section


  const sliderSettings = {
    centerPadding: '96px',
    arrows: false,
    infinite: true,
    swipeToSlide: true,
    slidesToScroll: 1,
    slidesToShow: 5,
    centerMode: false,
    // prevArrow: (
    //   <button className={'outline-none'}>
    //     <span className={'block -ml-2 w-4 h-4 text-grey-100 opacity-30 hover:opacity-100'}>
    //       <Snippets.Icon name={'chevron_left'} width={18} />
    //     </span>
    //   </button>
    // ),
    // nextArrow: (
    //   <button className={'outline-none'}>
    //     <span className={'block -mr-4 w-4 h-4 text-grey-100 opacity-30 hover:opacity-100'}>
    //       <Snippets.Icon name={'chevron_right'} width={18} className={'text-black'}/>
    //     </span>
    //   </button>
    // ),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: '84px',
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 4,
          centerPadding: '40px',
        }
      }
    ]
  }

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images
    let backgroundColor = ''
    if (settings.backgroundColor) {
      backgroundColor = ' bg-core-pale'
    }
    let results = products
    if (products.length) {
      while(results.length < 5) {
        results = [...results, ...products]
      }
    }
    
    return (
      <div className={backgroundColor}>
        <div className={`w-full flex flex-col items-center pt-2 md:pt-3-2 ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
          <Snippets.Heading size={'h3'} tag={'p'} className={'tracking-wider w-full text-center mb-2-4 md:mb-4'}>{settings.title}</Snippets.Heading>
          {settings && settings.addArrows && (
            <div className="flex flex-row justify-end w-full mb-2">
              <div className='flex items-center justify-between md:justify-end'>
                <button className="button px-1-2" onClick={this.previous}>
                  <Snippets.Icon name={'arrow_left'} width={18} label={'previous slide'} />
                </button>
                <button className="button px-1-2" onClick={this.next}>
                  <Snippets.Icon name={'arrow_right'} width={18} label={'next slide'} />
                </button>
              </div>
            </div>
          )}
          <div className={'w-full pl-0-8 md:pl-0'}>
            <Snippets.Slider settings={{ ...sliderSettings }} className={''} refs={this.sliderRef}>
              {results.map((product: any, i: number) => {
                return <Snippets.CollectionProduct
                  key={i}
                  product={product}
                  layout={'slider'}
                  border
                  list="Feature collection section"
                  collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                  isInWishlist={this.checkWishlistItem(product)}
                  toggleWishlist={this.toggleWishlist}
                  wishlist={this.state.wishlist}
                />
              })}
            </Snippets.Slider>
          </div>
          {settings.buttontext && <Snippets.Button colour={settings.buttoncolour === 'black' ? 'primary' : 'secondary'} type="button" className="my-2-4 md:my-4 uppercase p-1" title={settings.buttontext} href={settings.buttonlink}>{ settings.buttontext }</Snippets.Button>}
        </div>
      </div>
    )
  }

}

export namespace DynamicFeaturedCollection {
  export interface Options extends ShopifyNext.Section {
    block_size: number;
    buttontext: string;
    buttonlink: string;
    addArrows: boolean;
  }
  export interface Props extends GlobalProps {
    section: DynamicFeaturedCollection.Options;
  }
  export interface State {
    products: any;
    wishlist: any[];
  }
}
